import { configureStore, combineReducers } from "@reduxjs/toolkit";
import { apiSlice } from "./apiSlice";
import myInfoReducer from "./slice/myInfoSlice";
import loadingReducer, { startLoading, endLoading } from "./slice/loadingSlice";

// 전역 로딩에서 제외할 API 엔드포인트들
const LOADING_EXCLUDED_ENDPOINTS = [
    "getMyInfo", // (헤더) 사용자 정보 조회
    "getNotificationList", // (헤더) 알림 목록
    "getAddressCode", // 주소 조회
    "getAddressCode2", // 주소 조회
];

const appReducer = combineReducers({
    myInfo: myInfoReducer,
    loading: loadingReducer,
    [apiSlice.reducerPath]: apiSlice.reducer,
});

// 로그아웃 액션 감지, 전체 상태 초기화 rootReducer
const rootReducer = (state, action) => {
    if (action.type === "LOGOUT") {
        state = undefined; // 모든 상태 초기화
    }
    return appReducer(state, action);
};

// RTK Query 액션 감지, 로딩 상태 관리 미들웨어
const loadingMiddleware = (store) => (next) => (action) => {
    // RTK Query의 API 액션인지 체킹
    if (action.type?.includes("api/executeQuery") || action.type?.includes("api/executeMutation")) {
        const endpointName = action.meta?.arg?.endpointName;

        // 제외 목록에 있는 엔드포인트는 전역 로딩에서 제외
        if (endpointName && LOADING_EXCLUDED_ENDPOINTS.includes(endpointName)) {
            return next(action);
        }

        if (action.type?.endsWith("/pending")) {
            store.dispatch(startLoading());
        } else if (action.type?.endsWith("/fulfilled") || action.type?.endsWith("/rejected")) {
            store.dispatch(endLoading());
        }
    }

    return next(action);
};

const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(apiSlice.middleware, loadingMiddleware),
});

export default store;
